import { v4 as uuid } from "uuid";
export const templateLibraryData = [
  {
    id: uuid(),
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "meditation__yoga_retreat",
    components: [
      {
        type: "BODY",
        text: "Escape the chaos at our Zen Den Retreat: 🗓️ Date: {{custom-variable1}} ⏰ Time: {{custom-variable2}} 📍 Location: {{custom-variable3}} 🧘 Guided meditation sessions 🧘 Yoga for all levels 🧘 Aromatherapy workshop To carry with you: Yoga mat, comfortable clothes, and an open mind.",
        example: {
          body_text: [
            [
              "Arjun",
              "Sunday, October 15th",
              "10 AM - 3 PM",
              "Tranquil Gardens Resort",
            ],
          ],
        },
      },
      { type: "FOOTER", text: "Don’t miss out!" },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Book Now", url: "" }],
      },
    ],
  },
  {
    id: 1,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "welcome_to_course",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2021/12/11/01/55/wing-6861729_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: "Hi {{first-name}}, welcome to {{shop-name}}! We’re thrilled to guide you on this learning journey.",
        example: { body_text: [["Arjun", "SkillMaster Academy"]] },
      },
      { type: "FOOTER", text: "Tap below to explore your dashboard." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Go to Dashboard", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 2,
    whatsapp_category_id: 1,
    whatsapp_language_id: 2,
    name: "purchase_confirmation",
    components: [
      {
        type: "HEADER",
        format: "DOCUMENT",
        example: {
          header_handle: ["https://pdfobject.com/pdf/sample.pdf"],
        },
      },
      {
        type: "BODY",
        text: 'Hello {{first-name}}, your payment for "{{custom-variable1}}" is confirmed. Download your receipt below.',
        example: { body_text: [["Sneha", "Advanced Photoshop"]] },
      },
      { type: "FOOTER", text: "Keep this for your records." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Download Receipt", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 3,
    whatsapp_category_id: 1,
    whatsapp_language_id: 1,
    name: "class_reminder",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "⏰ Upcoming Session",
      },
      {
        type: "BODY",
        text: 'Reminder: Your live class "{{custom-variable1}}" is on {{custom-variable2}} at {{custom-variable3}}.',
        example: { body_text: [["UX Mastery", "May 5", "7:00 PM"]] },
      },
      { type: "FOOTER", text: "Click below to join on time." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Join Live Class", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 4,
    whatsapp_category_id: 1,
    whatsapp_language_id: 2,
    name: "certificate_ready",
    components: [
      {
        type: "HEADER",
        format: "DOCUMENT",
        example: {
          header_handle: ["https://pdfobject.com/pdf/sample.pdf"],
        },
      },
      {
        type: "BODY",
        text: 'Congrats {{first-name}}! You’ve completed "{{custom-variable1}}". Your certificate is now available.',
        example: { body_text: [["Riya", "Digital Marketing 101"]] },
      },
      { type: "FOOTER", text: "Download it below." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Get Certificate", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 5,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "premium_course_offer",
    components: [
      {
        type: "HEADER",
        format: "VIDEO",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/video/2015/10/16/1046-142621379_tiny.mp4",
          ],
        },
      },
      {
        type: "BODY",
        text: '{{first-name}}, ready to upskill? Check out our premium course "{{custom-variable1}}" for advanced learners.',
        example: { body_text: [["Neil", "Fullstack Bootcamp"]] },
      },
      { type: "FOOTER", text: "Limited seats available." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Enroll Now", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 6,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "daily_learning_tip",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "💡 Tip of the Day",
      },
      {
        type: "BODY",
        text: 'Hey {{first-name}}, here’s today’s tip: "{{custom-variable1}}". Apply it now!',
        example: {
          body_text: [["Anita", "Break problems into smaller tasks"]],
        },
      },
      { type: "FOOTER", text: "Stay consistent!" },
      {
        type: "BUTTONS",
        buttons: [{ type: "QUICK_REPLY", text: "More Tips" }],
      },
    ],
  },
  {
    id: 7,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "limited_time_discount",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/06/06/50/parrot-8368951_1280.png",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, enjoy {{offer-code}}% off on "{{custom-variable1}}" until {{custom-variable2}}.',
        example: {
          body_text: [["Maya", "20", "Data Science Bootcamp", "May 10"]],
        },
      },
      { type: "FOOTER", text: "Hurry, offer ends soon!" },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Claim Discount", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 8,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "new_course_launch",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "🚀 New Course Alert!",
      },
      {
        type: "BODY",
        text: 'Hey {{first-name}}, our new course "{{custom-variable1}}" is live. Be among the first to enroll!',
        example: { body_text: [["Sahil", "AI for Everyone"]] },
      },
      { type: "FOOTER", text: "Kickstart your journey today." },
      {
        type: "BUTTONS",
        buttons: [{ type: "QUICK_REPLY", text: "Enroll Now" }],
      },
    ],
  },
  {
    id: 9,
    whatsapp_category_id: 1,
    whatsapp_language_id: 1,
    name: "feedback_request",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "📝 We Value Your Feedback",
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, how was your experience with "{{custom-variable1}}"? It’s quick—just 30 seconds!',
        example: { body_text: [["Rohit", "UX Design Basics"]] },
      },
      { type: "FOOTER", text: "Help us improve." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Give Feedback", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 10,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "personalized_course_recommendation",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2015/05/31/15/14/woman-792162_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Based on your interest in "{{custom-variable1}}", we recommend "{{custom-variable2}}" for you.',
        example: { body_text: [["Content Writing", "SEO Mastery"]] },
      },
      { type: "FOOTER", text: "Start learning now!" },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "View Course", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 11,
    whatsapp_category_id: 1,
    whatsapp_language_id: 2,
    name: "assignment_reminder",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "📚 Assignment Due",
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, don’t forget to submit your assignment for "{{custom-variable1}}" by {{custom-variable2}}.',
        example: { body_text: [["Priya", "Photography Basics", "May 7"]] },
      },
      { type: "FOOTER", text: "Submit it before the deadline." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Submit Now", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 12,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "webinar_invite",
    components: [
      {
        type: "HEADER",
        format: "VIDEO",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/video/2015/10/16/1046-142621379_tiny.mp4",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Hey {{first-name}}, join our free webinar "{{custom-variable1}}" on {{custom-variable2}} at {{custom-variable3}}.',
        example: {
          body_text: [["Anika", "Growth Hacking", "May 8", "5:00 PM"]],
        },
      },
      { type: "FOOTER", text: "Seats are limited." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Register Now", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 13,
    whatsapp_category_id: 1,
    whatsapp_language_id: 2,
    name: "support_contact",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "❓ Need Help?",
      },
      {
        type: "BODY",
        text: "Hi {{first-name}}, if you have any questions, reach out to our support at {{email-id}} or call {{country-code}}{{mobile-number}}.",
        example: { body_text: [["Rahul", "+91", "9876543210"]] },
      },
      { type: "FOOTER", text: "We’re here for you 24/7." },
      {
        type: "BUTTONS",
        buttons: [{ type: "QUICK_REPLY", text: "Contact Support" }],
      },
    ],
  },
  {
    id: 14,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "alumni_group_invite",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/22/09/17/manager-8405057_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Congrats {{first-name}}! Join our alumni community for "{{custom-variable1}}" to network and grow.',
        example: { body_text: [["Sneha", "Digital Marketing 101"]] },
      },
      { type: "FOOTER", text: "Click below to join now." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Join Alumni", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 15,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "early_bird_offer",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "🔥 Early Bird Special",
      },
      {
        type: "BODY",
        text: 'Hey {{first-name}}, grab early bird price for "{{custom-variable1}}" at {{offer-code}}% off. Offer ends {{custom-variable2}}.',
        example: { body_text: [["Anjali", "UI/UX Workshop", "15"]] },
      },
      { type: "FOOTER", text: "Don’t miss out!" },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Claim Early Bird", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 16,
    whatsapp_category_id: 1,
    whatsapp_language_id: 1,
    name: "checkin_message",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "👋 Quick Check-In",
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, how’s your progress in "{{custom-variable1}}" going? Let us know!',
        example: { body_text: [["Vikram", "JavaScript Essentials"]] },
      },
      { type: "FOOTER", text: "We’re here to help." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "QUICK_REPLY", text: "I’m Good" },
          { type: "QUICK_REPLY", text: "Need Help" },
        ],
      },
    ],
  },
  {
    id: 17,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "trend_update",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/22/09/17/manager-8405057_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, here’s the latest trend: "{{custom-variable1}}". Stay ahead of the curve!',
        example: { body_text: [["Ria", "Voice Search Optimization"]] },
      },
      { type: "FOOTER", text: "Learn more in our blog." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Read Blog", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 18,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "partnership_announcement",
    components: [
      {
        type: "HEADER",
        format: "VIDEO",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/video/2015/10/16/1046-142621379_tiny.mp4",
          ],
        },
      },
      {
        type: "BODY",
        text: "Exciting news {{first-name}}! We’ve partnered with {{custom-variable1}} to bring you exclusive content.",
        example: { body_text: [["TechWorld"]] },
      },
      { type: "FOOTER", text: "Stay tuned for updates." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Learn More", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 19,
    whatsapp_category_id: 1,
    whatsapp_language_id: 2,
    name: "testimonial_request",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "🌟 Share Your Story",
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, would you mind sharing a short testimonial about "{{custom-variable1}}"?',
        example: { body_text: [["Lakshmi", "Leadership Essentials"]] },
      },
      { type: "FOOTER", text: "It helps future learners." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Submit Testimonial", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 20,
    whatsapp_category_id: 1,
    whatsapp_language_id: 1,
    name: "subscription_renewal",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "🔄 Renewal Reminder",
      },
      {
        type: "BODY",
        text: 'Hello {{first-name}}, your subscription for "{{custom-variable1}}" expires on {{custom-variable2}}.',
        example: { body_text: [["Raghav", "Monthly Coaching", "May 20"]] },
      },
      { type: "FOOTER", text: "Renew to keep learning." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Renew Now", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 21,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "self_paced_course_reminder",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/22/09/17/manager-8405057_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Hey {{first-name}}, continue your self-paced course "{{custom-variable1}}" at your convenience.',
        example: { body_text: [["Meera", "Python Fundamentals"]] },
      },
      { type: "FOOTER", text: "Learn anytime, anywhere." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Resume Course", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 22,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "course_start_countdown",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "⏳ Countdown to Start",
      },
      {
        type: "BODY",
        text: 'Only {{custom-variable1}} days left until "{{custom-variable2}}" begins. Get ready!',
        example: { body_text: [["3", "React Native Bootcamp"]] },
      },
      { type: "FOOTER", text: "Mark your calendar." },
      {
        type: "BUTTONS",
        buttons: [{ type: "QUICK_REPLY", text: "View Schedule" }],
      },
    ],
  },
  {
    id: 23,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "highlight_video_snippet",
    components: [
      {
        type: "HEADER",
        format: "VIDEO",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/video/2015/10/16/1046-142621379_tiny.mp4",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Check out this sneak peek from "{{custom-variable1}}"! Watch now.',
        example: { body_text: [["Social Media Mastery"]] },
      },
      { type: "FOOTER", text: "Inspired? Enroll today." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Watch Full Video", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 24,
    whatsapp_category_id: 1,
    whatsapp_language_id: 1,
    name: "ebook_download",
    components: [
      {
        type: "HEADER",
        format: "DOCUMENT",
        example: {
          header_handle: ["https://pdfobject.com/pdf/sample.pdf"],
        },
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, download your free eBook "{{custom-variable1}}" here.',
        example: { body_text: [["Arjun", "Ultimate Coding Guide"]] },
      },
      { type: "FOOTER", text: "Happy reading!" },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Download eBook", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 25,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "blog_post_share",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/22/09/17/manager-8405057_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, new on our blog: "{{custom-variable1}}". Read insights and tips!',
        example: { body_text: [["Riya", "5 Tips for Effective Learning"]] },
      },
      { type: "FOOTER", text: "Click to read more." },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Read Blog", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 26,
    whatsapp_category_id: 1,
    whatsapp_language_id: 1,
    name: "milestone_celebration",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/22/09/17/manager-8405057_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Congratulations {{first-name}}! You’ve reached {{custom-variable1}}% completion in "{{custom-variable2}}".',
        example: { body_text: [["Vikram", "75", "React Fundamentals"]] },
      },
      { type: "FOOTER", text: "Keep up the great work!" },
      {
        type: "BUTTONS",
        buttons: [{ type: "QUICK_REPLY", text: "View Progress" }],
      },
    ],
  },
  {
    id: 27,
    whatsapp_category_id: 2,
    whatsapp_language_id: 2,
    name: "case_study_document",
    components: [
      {
        type: "HEADER",
        format: "DOCUMENT",
        example: {
          header_handle: ["https://pdfobject.com/pdf/sample.pdf"],
        },
      },
      {
        type: "BODY",
        text: 'Explore our case study "{{custom-variable1}}" to see real results.',
        example: { body_text: [["Boosting Conversions"]] },
      },
      { type: "FOOTER", text: "Insights await inside." },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Download Case Study", url: "{{website-url}}" },
        ],
      },
    ],
  },
  {
    id: 28,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "infographic_share",
    components: [
      {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            "https://cdn.pixabay.com/photo/2023/11/22/09/17/manager-8405057_1280.jpg",
          ],
        },
      },
      {
        type: "BODY",
        text: 'Check out this infographic on "{{custom-variable1}}". Quick visual guide for you!',
        example: { body_text: [["Time Management Hacks"]] },
      },
      { type: "FOOTER", text: "Share with your peers." },
      {
        type: "BUTTONS",
        buttons: [{ type: "QUICK_REPLY", text: "Share Now" }],
      },
    ],
  },
  {
    id: 29,
    whatsapp_category_id: 1,
    whatsapp_language_id: 2,
    name: "birthday_greeting",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "🎂 Happy Birthday!",
      },
      {
        type: "BODY",
        text: "Wishing you a wonderful day, {{first-name}}! Enjoy a special {{offer-code}}% gift from us.",
        example: { body_text: [["Tara", "15"]] },
      },
      { type: "FOOTER", text: "Celebrate with learning!" },
      {
        type: "BUTTONS",
        buttons: [{ type: "URL", text: "Redeem Gift", url: "{{website-url}}" }],
      },
    ],
  },
  {
    id: 30,
    whatsapp_category_id: 2,
    whatsapp_language_id: 1,
    name: "community_update",
    components: [
      {
        type: "HEADER",
        format: "TEXT",
        text: "🌐 Community News",
      },
      {
        type: "BODY",
        text: 'Hi {{first-name}}, our community discussion on "{{custom-variable1}}" is live. Join in!',
        example: { body_text: [["Digital Storytelling"]] },
      },
      { type: "FOOTER", text: "See you there!" },
      {
        type: "BUTTONS",
        buttons: [
          { type: "URL", text: "Join Discussion", url: "{{website-url}}" },
        ],
      },
    ],
  },
];

export const templateCategory = [
  {
    id: 1,
    name: "Utility",
  },
  {
    id: 2,
    name: "Marketing",
  },
  {
    id: 3,
    name: "Authentication",
  },
];
